export class storeManagementController {
    ajaxLoading: boolean = false;
    user: any;
    currentNavItem: any;
    loadComplete: boolean = false;
    constructor(private $rootScope, private $ocLazyLoad, private $state, private MyConstant, private $vendor) {
        "ngInject"

    }
    $onInit() {
        
        if (this.MyConstant.Type == 'bazaryab') {

            this.$vendor.checkState(Response => {
                this.user = Response
                this.ajaxLoading = false;
            })
        }
        else {
            this.user = {
                ActiveStatus: "Active"
            }
            this.ajaxLoading = false;
        }
        this.$ocLazyLoad.load("management").then(res => {
            this.loadComplete = true
        })
        if (!this.$state.current.parent) {
            this.$state.go('selectProduct')
            this.currentNavItem = 'selectProduct'
        }
        else {
            this.currentNavItem = this.$state.current.name;
        }
    }

}


// WEBPACK FOOTER //
// ./src/components/store-management/store-management.controller.ts